











































































































































import { Component, Watch } from 'vue-property-decorator';
import { visit } from '@/lib';
import { DienstleisterDienstleistungInfo, KonzerngesellschaftInfo } from '@/Verarbeitungstaetigkeit/api-vtaetigkeit';
import { Auswahlliste, Auswahl, AuswahllistenElement } from '@/api';
import { Element, Auswahl as UIAuswahl, TextZusatzSymbol } from '@/components/Auswahlliste';
import GuardileoAuswahlliste from '@/components/GuardileoAuswahlliste.vue';
import DienstleisterLegende from "@/components/DienstleisterLegende.vue";
import BeteiligteUnternehmenMultiselect, {Option} from '@/views/Verarbeitungstaetigkeit/BeteiligteUnternehmenMultiselect.vue';
import { DrittlandtransferpruefungTabBase } from './TabBase-dltp';

@Component({ components: { GuardileoAuswahlliste, DienstleisterLegende, BeteiligteUnternehmenMultiselect} })
export default class extends DrittlandtransferpruefungTabBase {
    private get datenempfaenger_extern(): (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)[] {
        if (!this.data) return [];

        // Es erfolgt keine Sortierung inaktiver Dienstleister nach unten, da für den Nutzer inaktive Dienstleister im Drittland
        // gut sichtbar bleiben sollen, da dies fachlich kein wünschenswerter Zustand ist und daher Handlungsbedarf besteht
        return this.data.StatischeDaten.Dienstleister.filter(_ => !_.IsKG).sort((a,b) => a.Bezeichnung<b.Bezeichnung ? -1 : +1);
    }

    private get datenempfaenger_konzern(): (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)[] {
        if (!this.data) return [];
        return [
            ...(this.data.StatischeDaten.Dienstleister.filter(_ => _.IsKG) as (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)[]),  
            ...(this.data.StatischeDaten.Konzerngesellschaften as (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)[]),
        ].sort((a,b) => a.Bezeichnung<b.Bezeichnung ? -1 : +1);
    }

    
    private get listeMitInjectedSonstigeText() {
      if (this.auswahllisten["e79e893a-d149-4c5c-bb68-208962eb5362"].Elemente) {
        const liste: AuswahllistenElement[] = 
          this.auswahllisten["e79e893a-d149-4c5c-bb68-208962eb5362"].Elemente
        if(this.data && this.data.Verarbeitungstaetigkeit) {
            const {BetroffenePersonenSonstigeBeschreibung} = this.data.Verarbeitungstaetigkeit;
            const sonstigeId = "5a5a3791-0fd0-45af-9c2f-eece04f38267";
            const index = liste.findIndex((c) => c.ElementId === sonstigeId);
            if(index !== -1 && BetroffenePersonenSonstigeBeschreibung) {
                liste[index] = {...liste[index], [TextZusatzSymbol]: `(${BetroffenePersonenSonstigeBeschreibung})`}
            }
        } else {
            return liste;
        } return liste;
      } else return [];
    }
    
    async mounted() {
        //console.log(this.datenempfaenger_extern);
    }

    loaded() {
    }

    async save_changes(event: any) {
        event.preventDefault();
        if (!this.can_save) return;
        this.data = await this.guard_save(() => this.api.Angaben_aendern_datenuebermittlung(this.id, {
            Eintraege: Object.values(this.auswahl),
            Datenuebermittlung_alle: this.data!.Angaben.Datenuebermittlung_alle,
            Datenuebermittlung_Kinder: this.data!.Angaben.Datenuebermittlung_Kinder,
            Datenuebermittlung_Dauer_und_Komplexitaet: this.data!.Angaben.Datenuebermittlung_Dauer_und_Komplexitaet,
            Datenuebermittlung_Angemessenheit: this.data!.Angaben.Datenuebermittlung_Angemessenheit,
        }));
        this.on_data();
    }        

    get valid(): boolean {
        return true;
    }        
    getColor(Dienstleister: (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)){
        
        if(!Dienstleister.Dienstleistungen){ 
            // für reine Konzerngesellschaften sind die Dienstleistungen undefined
            return 'bg-white';
        }
        if(Dienstleister.IstAktiv){
            return "status-class-" + Dienstleister.Status;
        } 
        else{
            return "status-class-900";
        }
    }
    getIcon(Dienstleister: (DienstleisterDienstleistungInfo & KonzerngesellschaftInfo)){
        
        if(!Dienstleister.Dienstleistungen){ 
            // für reine Konzerngesellschaften sind die Dienstleistungen undefined
            return 'firma';
        }
        else{
            return "dienstleister";
        }
    }
}
